import React from 'react';

import {
  useOverrideCachedOrderMutation,
  useValidateCachedOrderLazyQuery,
  useValidateOrderActivityQuery
} from 'generated/graphql';

import { Schema } from 'jsonschema';



export interface IData {
  originalOrder: unknown;
  salesOrderSchema: Schema;
  storeId: string;
}

export function useQuery(externalOrderId: string) {
  const tuple = useValidateOrderActivityQuery({
    variables: {
      externalOrderId
    }
  });

  return React.useMemo(
    () => {
      const originalOrder = tuple.data?.cachedOrder?.rawData ?? {};
      const data: IData = {
        storeId: tuple.data?.cachedOrder?.store.id ?? '',
        originalOrder,
        salesOrderSchema: tuple.data?.cachedOrder?.store.salesOrderValidator ?? {}
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useValidateCachedOrder(externalOrderId: string) {
  const [fnQuery, tuple] = useValidateCachedOrderLazyQuery({
  });

  const fnWrappedQuery = React.useCallback(
    async (rawData: unknown) => {
      const response = await fnQuery({
        fetchPolicy: 'network-only',
        variables: {
          input: {
            externalOrderId,
            rawData
          }
        }
      });
      return response.data?.validateCachedOrder ?? [];
    },
    [
      externalOrderId,
      fnQuery
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedQuery,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedQuery,
      tuple
    ]
  );
}



export function useOverrideCachedOrder(externalOrderId: string) {
  const [fnMutate, tuple] = useOverrideCachedOrderMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (rawData: unknown) => {
      await fnMutate({
        variables: {
          input: {
            externalOrderId,
            rawData
          }
        }
      });
    },
    [
      fnMutate,
      externalOrderId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
